export const emergencyTypeMapper = (emergencyType, title) => {
  const map = {
    MEDICAL: title ? 'EMS' : 'alerts_medical',
    ACTIVE_ASSAILANT: title ? 'Active Assailant' : 'alerts_active_assailant',
    TRAIN_DERAILMENT: title ? 'Train Incident' : 'alerts_train_incident',
    RAIL_FIRE: title ? 'Train Incident' : 'alerts_train_incident',
    HAZMAT_RELEASE: title ? 'Train Incident' : 'alerts_train_incident',
    NO_INCIDENT: title ? 'Train Incident' : 'alerts_train_incident',
    FIRE: title ? 'Fire' : 'alerts_fire',
    CO: title ? 'Fire' : 'alerts_fire',
    FE: title ? 'Fire' : 'alerts_fire',
    HOLDUP: title ? 'Police' : 'alerts_law_enforcement',
    BURGLARY: title ? 'Police' : 'alerts_law_enforcement',
    SILENT_ALARM: title ? 'Police' : 'alerts_law_enforcement',
    CRASH: title ? 'Police' : 'alerts_law_enforcement',
    OTHER: title ? 'Police' : 'alerts_law_enforcement',
    MOBILE_PANIC: title ? 'Police' : 'alerts_law_enforcement',
  };
  return map[emergencyType] || '';
};
